import { z } from "zod";
import { Geometry } from "geojson";

export const ViewPortSchema = z.object({
  boundGeoJson: z.custom<Geometry>(),
  bounds: z.object({
    west: z.number(),
    south: z.number(),
    east: z.number(),
    north: z.number(),
  }),
  zoomLevel: z.number(),
});

export const ContextSchema = z.object({
  selection: z
    .object({
      info: z.object({
        geometry: z.custom<Geometry>(),
        id: z.string(),
        type: z.string(), // TODO Get the selection types from the FE
        titleNumber: z.string().nullable(),
      }),
      bufferedInfo: z
        .object({
          geometry: z.custom<Geometry>(),
          radius: z.number(),
        })
        .optional(),
    })
    .optional(),
  userPreferences: z.object({
    measurementSystem: z.enum(["imperial", "metric"]),
  }),
  viewPort: ViewPortSchema,
});

export type ViewPort = z.infer<typeof ViewPortSchema>;
export type AgentContext = z.infer<typeof ContextSchema>;
